export default "__VITE_ASSET__$FzxZYej__"